<template>
  <div>
    <div class="d-flex">
      <slot name="nav-prev">
        <AppButton data-el="nav-prev" :disabled="!mergedOptions.allowSlidePrev || loading">
          <AppIcon name="arrow_back" />
        </AppButton>
      </slot>
      <slot v-if="loading" name="loading">
        <p class="w-100 text-muted font-italic text-center my-3">Loading...</p>
      </slot>
      <!-- 1. We have to have a conditional rendering (`loading` flag), because swiper doesn't swipe -->
      <!-- when one img available, and we upload a 2nd one. It has to be initiated again to work. -->
      <!-- 2. Also, `ref="swiper"` is not used here, but is in some parent components to retrieve `activeIndex` -->
      <Swiper
        v-else
        v-bind="$attrs"
        ref="swiper"
        :options="mergedOptions"
        :style="swiperStyle"
      >
        <SwiperSlide
          v-for="(slide, index) of swiperSlides"
          :key="slide + index"
        >
          <slot name="slide" v-bind="{ slide }" />
        </SwiperSlide>
      </Swiper>
      <slot name="nav-next">
        <AppButton data-el="nav-next" :disabled="!mergedOptions.allowSlideNext || loading">
          <AppIcon name="arrow_forward" />
        </AppButton>
      </slot>
    </div>
    <div data-el="pagination" class="app-swiper__pagination mt-3 text-center"></div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    Swiper: swiper,
    SwiperSlide: swiperSlide,
  },
  props: {
    swiperSlides: {
      type: Array,
      default: () => ([]),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    // We cannot use `inheritAttrs: false` to bind class and style into desired element
    swiperStyle: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({ swiperWidth: 0 }),
  computed: {
    mergedOptions () {
      return {
        allowSlidePrev: true,
        allowSlideNext: true,
        centeredSlides: true,
        spaceBetween: 24,
        slidesPerView: 1,
        navigation: {
          prevEl: '[data-el=\'nav-prev\']',
          nextEl: '[data-el=\'nav-next\']',
        },
        pagination: {
          clickable: true,
          el: '[data-el=\'pagination\']',
        },
        ...this.options,
      }
    },
  },
}
</script>

<style src="swiper/dist/css/swiper.css"></style>
<style lang="css" scoped>
/* `options.slideClass` somehow breaks the swiper, so it's easier to just style here */
.swiper-slide {
  text-align: center;
}

.app-swiper__pagination >>> span {
  margin-left: 8px;
  margin-right: 8px;
  cursor: pointer;
}
</style>
